/* ============================================================
   ELLOKE — efeitos extras da home
   1. Botões magnéticos: o botão inclina-se levemente na direção
      do cursor e volta com mola ao sair.
   2. Cards 3D: cartões de produto/categoria inclinam conforme a
      posição do mouse, com brilho acompanhando.
   Desligado no touch e com prefers-reduced-motion.
   ============================================================ */

(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (REDUCED || !FINE) return;

  /* ---------- 1. BOTÕES MAGNÉTICOS ---------- */

  function initMagnetic(scope) {
    scope.querySelectorAll('.ut-btn, .cb-btn').forEach(function (btn) {
      if (btn.dataset.elkBound === 'true') return;
      btn.dataset.elkBound = 'true';

      var strength = 10; // px máximos de deslocamento

      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width - 0.5) * 2;
        var y = ((e.clientY - r.top) / r.height - 0.5) * 2;
        btn.style.transition = 'transform 120ms ease-out';
        btn.style.transform = 'translate(' + (x * strength).toFixed(1) + 'px, ' + (y * strength * 0.7).toFixed(1) + 'px)';
      });

      btn.addEventListener('mouseleave', function () {
        btn.style.transition = 'transform 480ms cubic-bezier(0.34, 1.56, 0.64, 1)';
        btn.style.transform = 'translate(0, 0)';
      });
    });
  }

  /* ---------- 2. CARDS COM INCLINAÇÃO 3D ---------- */

  function initTilt(scope) {
    scope.querySelectorAll('.ut-tile__media, .cb-card__media, .ut-ig__photo').forEach(function (card) {
      if (card.dataset.elkBound === 'true') return;
      card.dataset.elkBound = 'true';

      var host = card.closest('a, [data-cb-card], .ut-ig__card') || card;

      host.style.perspective = '900px';
      card.style.transformStyle = 'preserve-3d';
      card.style.willChange = 'transform';

      host.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transition = 'transform 140ms ease-out';
        card.style.transform =
          'rotateY(' + (x * 6).toFixed(2) + 'deg) rotateX(' + (y * -6).toFixed(2) + 'deg) scale(1.015)';
      });

      host.addEventListener('mouseleave', function () {
        card.style.transition = 'transform 600ms cubic-bezier(0.16, 1, 0.3, 1)';
        card.style.transform = 'rotateY(0) rotateX(0) scale(1)';
      });
    });
  }

  /* ---------- BOOT ---------- */

  window.ElkFx = window.ElkFx || {};

  window.ElkFx.init = function (scope) {
    var root = scope || document;
    initMagnetic(root);
    initTilt(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { window.ElkFx.init(); });
  } else {
    window.ElkFx.init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    window.ElkFx.init(e.target);
  });
})();
